import { render, staticRenderFns } from "./full-application-sidebar.vue?vue&type=template&id=020545c7&scoped=true"
import script from "./full-application-sidebar.vue?vue&type=script&lang=ts"
export * from "./full-application-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./full-application-sidebar.vue?vue&type=style&index=0&id=020545c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020545c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020545c7')) {
      api.createRecord('020545c7', component.options)
    } else {
      api.reload('020545c7', component.options)
    }
    module.hot.accept("./full-application-sidebar.vue?vue&type=template&id=020545c7&scoped=true", function () {
      api.rerender('020545c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application/components/full-application-sidebar.vue"
export default component.exports